import { Controller } from '@hotwired/stimulus'
import { Helpers } from '../helpers'

export default class ChartjsController extends Controller {
  static values = {
    data: Object,
    type: String,
    options: Object
  };

  connect() {
    const defaultOptions = {
      money: false
    };
    const options = { ...defaultOptions, ...this.optionsValue };
    const data = this.dataValue;
    const type = this.typeValue;

    new Chart(this.element, {
      type,
      data,
      options: {
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: (value) => options.money ? Helpers.numberToCurrency(value) : value,
            }
          }
        },
        interaction: {
          mode: 'index',
          intersect: false,
        },
        plugins: {
          legend: {
            position: 'bottom',
            align: 'start',
            labels: {
              filter: item => item.fillStyle !== 'transparent'
            }
          },
          tooltip: {
            backgroundColor: 'rgba(26,25,25,0.8)',
            callbacks: {
              label: (tooltipItem) => {
                const value = options.money ? Helpers.numberToCurrency(tooltipItem.raw, 2, true) : tooltipItem.raw;
                const tooltipLabel = data.datasets[tooltipItem.datasetIndex].tooltip_label;
                return `${tooltipLabel}${value}`;
              }
            }
          }
        }
      }
    });
  }
}
